var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass:
        "\n    fill-height\n    max-width\n    pa-0\n    d-flex\n    flex-row flex-grow-1\n    justify-space-between\n  ",
      attrs: { fluid: "" },
    },
    [
      _c("div", { staticClass: "max-width text-start pl-2" }, [
        _c(
          "div",
          {
            class:
              _vm.year.indexOf("-") != -1 ? "text-caption" : "text-caption",
          },
          [_vm._v(" " + _vm._s(_vm.year) + " " + _vm._s(_vm.month) + " ")]
        ),
        _c("div", { staticClass: "title font-weight-black" }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }